/* SPDX-License-Identifier: AGPL-3.0-or-later */

import { Component, input, output } from '@angular/core';
import {
  MatCell,
  MatCellDef,
  MatColumnDef,
  MatHeaderCell,
  MatHeaderCellDef,
  MatHeaderRow,
  MatHeaderRowDef,
  MatNoDataRow,
  MatRow,
  MatRowDef,
  MatTable,
} from '@angular/material/table';
import { NgClass, NgStyle } from '@angular/common';
import { QualificationTeamScoreDto, TeamDto } from '@api';
import { MatButton, MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';

@Component({
  selector: 'app-tournament-score-table',
  standalone: true,
  imports: [
    MatTable,
    MatColumnDef,
    MatHeaderCell,
    MatHeaderCellDef,
    MatCellDef,
    MatCell,
    MatHeaderRow,
    MatRow,
    MatRowDef,
    MatHeaderRowDef,
    NgStyle,
    NgClass,
    MatIconButton,
    MatIcon,
    MatTooltip,
    MatNoDataRow,
    MatButton,
  ],
  templateUrl: './tournament-score-table.component.html',
  styleUrl: './tournament-score-table.component.scss',
})
export class TournamentScoreTableComponent {
  scoreDtos = input<QualificationTeamScoreDto[]>();
  teams = input<Map<number, TeamDto>>();
  viewOnly = input<boolean>(false);
  checkInTeam = output<QualificationTeamScoreDto>();
  displayedColumns = ['position', 'name', 'gamesPlayed', 'wins', 'losses', 'points'];

  asScoreDto(element: QualificationTeamScoreDto): QualificationTeamScoreDto {
    return element;
  }

  teamIsCurrentlyPlaying(scoreDto: QualificationTeamScoreDto): boolean {
    return (scoreDto.id && this.teams()?.get(scoreDto.id)?.currentlyPlaying) || false;
  }
}
